import { Student } from '../student/types'

export enum AuthTypes {
  SIGN_IN_REQUEST = '@auth/SIGN_IN_REQUEST',
  LOADING = '@auth/LOADING',
  SIGN_IN_SUCCESS = '@auth/SIGN_IN_SUCCESS',
  SIGN_FAILURE = '@auth/SIGN_FAILURE',
  SIGN_OUT = '@auth/SIGN_OUT',
  REFRESH_TOKEN_REQUEST = '@auth/REFRESH_TOKEN_REQUEST',
  REFRESH_TOKEN_SUCCESS = '@auth/REFRESH_TOKEN_SUCCESS',
}

export interface SignInPayload {
  email: string
  password: string
}

export interface RefreshTokenPayload {
  refresh_token: string
}

export interface SignSuccessPayload {
  token: string
  refresh_token: string
  profile: Student
}

export interface RefreshSuccessPayload {
  token: string
  refresh_token: string
}

export interface AuthState {
  readonly token: string | null
  readonly refresh_token: string | null
  readonly signed: boolean
  readonly loading: boolean
}
